export const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY"
export const SET_SELECTED_BRAND = "SET_SELECTED_BRAND"
export const SET_SELECTED_MENU = "SET_SELECTED_MENU"
